import { createSlice } from '@reduxjs/toolkit';

interface HelpPopupState {
  isOpen: boolean;
}

const helpPopupInitialState: HelpPopupState = Object.freeze({
  isOpen: false,
});

const helpPopupSlice = createSlice({
  name: 'helpPopup',
  initialState: helpPopupInitialState,
  reducers: {
    openHelpPopup: (state) => {
      state.isOpen = true;
    },
    closeHelpPopup: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openHelpPopup, closeHelpPopup } = helpPopupSlice.actions;

export default helpPopupSlice.reducer;
